import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'
import store from '@/store'

export default {
  resetTranslations({ commit }) {
    commit(types.RESET_TRANSLATIONS)
  },
  setCriteriaChanged({ commit }, value) {
    commit(types.SET_CRITERIA_CHANGED, value)
  },
  async setStep({ commit, state, dispatch }, value) {
    if (value !== 99) {
      commit(types.SET_STEP, value)
      commit(types.SET_VISITED_STEP, value)
    }
    if (state.criteriaChanged) {
      // if anything was changed, save the Scan Pro Criteria
      let profile = store.getters['auth/profile']
      let data = {
        businessId: profile.location.Id,
        criteria: state.scanProCriteria,
        checklist: state.scanProChecklist
      }
      await startLoading(dispatch, 'saveScanProConfiguration', () => http.post('scanpro/SaveScanProConfiguration', data))
      commit(types.SET_CRITERIA_CHANGED, false)
    }
  },
  resetVisitedStep({ commit }, value) {
    commit(types.RESET_VISITED_STEP, value)
  },
  async getRecommendations({ commit, dispatch }, firm) {
    const r = await startLoading(dispatch, 'getRecommendations', () => http.get(`testdrive/testdriveRecommendations?firm=${firm}`))
    commit(types.SET_RECOMMENDATIONS, r.data)
    return r.data
  },
  async getRecommendation({ commit, dispatch }, testDriveRecommendation) {
    const r = await startLoading(dispatch, 'getRecommendation', () =>
      http.get(`testdrive/testdriveRecommendation?testDriveRecommendation=${testDriveRecommendation}`)
    )
    commit(types.SET_RECOMMENDATION, r.data)
    return r.data
  },
  async saveRecommendation({ dispatch, state }) {
    const r = await startLoading(dispatch, 'saveRecommendation', () =>
      http.post('testdrive/saveTestDriveRecommendation', {
        firm: state.recommendation.firm,
        testDriveRecommendation: state.recommendation.testDriveRecommendation,
        recommendation: state.recommendation.recommendation,
        driveType: state.recommendation.driveType,
        vehicleMake: state.recommendation.vehicleMake,
        recommendationText: state.recommendation.recommendationText
      })
    )
    return r.data
  },
  async deleteRecommendation({ dispatch }, testDriveRecommendation) {
    const r = await startLoading(dispatch, 'deleteRecommendation', () =>
      http.get(`testdrive/deleteTestdriveRecommendation?testDriveRecommendation=${testDriveRecommendation}`)
    )
    return r.data
  },
  async saveNewTranslation({ dispatch }, data) {
    const r = await startLoading(dispatch, 'saveNewTranslation', () => http.post('language/addTranslation', data))
    return r.data
  },
  async saveTranslation({ dispatch }, data) {
    const r = await startLoading(dispatch, 'saveTranslation', () => http.post('language/saveTranslation', data))
    return r.data
  },
  async getTranslations({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getTranslations', () =>
      http.get(`language/translations?translationType=${data.translationType}&languageCode=${data.languageCode}`)
    )
    commit(types.SET_TRANSLATIONS, r.data)
    return r.data
  },
  async deleteTranslation({ dispatch }, translation) {
    const r = await startLoading(dispatch, 'deleteTranslation', () => http.get(`language/deleteTranslation?translation=${translation}`))
    return r.data
  },
  resetTestDriveResultType({ commit }) {
    commit(types.RESET_RESULTTYPE)
  },
  updateTestDriveResultType({ commit }, data) {
    commit(types.UPDATE_RESULTTYPE, data)
  },
  async getTestDriveResultTypes({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getTestDriveResultTypes', () =>
      http.get('lookup/testdriveResultType', {
        params: options
      })
    )
    commit(types.SET_RESULTTYPES, r.data)
    return r.data
  },
  async getTestDriveResultType({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getTestDriveResultType', () => http.get(`lookup/testdriveResultType?testdriveResultType=${id}`))
    commit(types.SET_RESULTTYPE, r.data)
    return r.data
  },
  async saveTestDriveResultType({ state, dispatch }) {
    const r = await startLoading(dispatch, 'saveTestDriveResultType', () => http.post('lookup/saveTestdriveResultType', state.testdriveResultType))
    return r.data
  },
  async getAdasExclusions({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'getAdasExclusions', () => http.get('admin/getAdasExclusions'))
    commit(types.SET_ADAS_EXCLUSIONS, r.data)
    return r.data
  },
  async deleteAdasExclusion({ state, dispatch }, id) {
    const r = await startLoading(dispatch, 'deleteAdasExclusion', () => http.get(`admin/deleteAdasExclusion?id=${id}`))
    return r.data
  },
  async saveAdasExclusion({ state, dispatch }, exclusion) {
    const r = await startLoading(dispatch, 'saveAdasExclusion', () => http.post('admin/saveAdasExclusion', exclusion))
    return r.data
  },
  initAdasMatrix({ commit }) {
    commit(types.INIT_ADAS_MATRIX)
  },
  updateAdasMatrix({ commit }, data) {
    commit(types.UPDATE_ADAS_MATRIX, data)
  },
  updateAdasMatrixItem({ commit }, data) {
    commit(types.UPDATE_ADAS_MATRIXITEM, data)
  },
  getAdasMatrix({ commit }, id) {
    commit(types.SET_ADAS_MATRIX, id)
  },
  resetAdasMatrices({ commit }) {
    commit(types.RESET_ADAS_MATRICES)
  },
  async getAdasMatrices({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getAdasMatrices', () =>
      http.get('admin/getAdasMatrix', {
        params: options
      })
    )
    commit(types.SET_ADAS_MATRICES, r.data)
    return r.data
  },
  async deleteAdasMatrix({ state, dispatch }, id) {
    const r = await startLoading(dispatch, 'deleteAdasMatrix', () => http.get(`admin/deleteAdasMatrix?id=${id}`))
    return r.data
  },
  async saveAdasMatrix({ state, dispatch }, item) {
    const r = await startLoading(dispatch, 'saveAdasMatrix', () => http.post('admin/saveAdasMatrix', item))
    return r.data
  },
  async decodeVin({ commit, dispatch }, vin) {
    const r = await startLoading(dispatch, 'decodeVin', () => http.get(`decode/adas?vin=${vin}`))
    commit(types.SET_DECODED_VIN, r.data)
    return r.data
  },
  async neoDecodeVin({ commit, dispatch }, data) {
    commit(types.RESET_DECODED_ALT_VIN)
    console.log('Neo Decode', {
      vin: data.vin,
      force: data.force
    })
    const r = await startLoading(dispatch, 'altDecodeVin', () => http.get(`decode/neo?vin=${data.vin}&force=${data.force}`))
    commit(types.SET_DECODED_ALT_VIN, r.data)
    return r.data
  },
  async cdkDecodeVin({ commit, dispatch }, vin) {
    const r = await startLoading(dispatch, 'decodeVin', () => http.get(`decode/adascdk?vin=${vin}`))
    commit(types.SET_DECODED_VIN, r.data)
    return r.data
  },
  initMakeMatrix({ commit }) {
    commit(types.INIT_ADAS_MAKE_MATRIX)
  },
  updateAdasMakeMatrix({ commit }, data) {
    if (data) {
      commit(types.UPDATE_ADAS_MAKE_MATRIX, data)
    } else {
      console.log('Attempted to assign null value to: ', types.UPDATE_ADAS_MAKE_MATRIX)
    }
  },
  initAdasMatrixInfoLookup({ commit }) {
    commit(types.INIT_ADAS_MATRIX_INFO_LOOKUP)
  },
  updateAdasMatrixInfoLookup({ commit }, data) {
    commit(types.UPDATE_ADAS_MATRIX_INFO_LOOKUP, data)
  },
  async getAdasMakeMatrices({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getAdasMakeMatrices', () =>
      http.get('admin/getAdasMakeMatrices', {
        params: options
      })
    )
    commit(types.SET_ADAS_MAKE_MATRICES, r.data)
    return r.data
  },
  async getAdasMakeMatrix({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getAdasMakeMatrix', () => http.get(`admin/getAdasMakeMatrix?id=${id}`))
    commit(types.SET_ADAS_MAKE_MATRIX, r.data)
    return r.data
  },
  async deleteAdasMakeMatrix({ state, dispatch }, id) {
    const r = await startLoading(dispatch, 'deleteAdasMakeMatrix', () => http.get(`admin/deleteAdasMakeMatrix?id=${id}`))
    return r.data
  },
  async saveAdasMakeMatrix({ commit, dispatch }, data) {    
    const r = await startLoading(dispatch, 'saveAdasMakeMatrix', () => http.post('admin/saveAdasMakeMatrix', data))
    commit(types.SET_ADAS_MAKE_MATRIX_ID, r.data)
    return r.data
  },
  async saveAdasMakeMatrixLookups({ state, dispatch }, data) {
    let lookups = {
      adasChecklistMatrix: data.adasChecklistMatrix,
      adasChecklistMatrixVehicle: data.adasChecklistMatrixVehicle,
      systems: data.systems,
      locations: data.locations,
      static: data.static,
      dynamic: data.dynamic
    }
    const r = await startLoading(dispatch, 'saveAdasMakeMatrixLookups', () => http.post('admin/saveAdasMakeMatrixLookups', lookups))
    return r.data
  },
  async getAdasMatrixInfoLookups({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getAdasMatrixInfoLookups', () =>
      http.get('admin/getAdasMatrixInfoLookups', {
        params: options
      })
    )
    commit(types.SET_ADAS_MATRIX_INFO_LOOKUPS, r.data)
    return r.data
  },
  async getAdasMatrixInfoLookup({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getAdasMatrixInfoLookup', () => http.get(`admin/getAdasMatrixInfoLookup?id=${id}`))
    commit(types.SET_ADAS_MATRIX_INFO_LOOKUP, r.data)
    return r.data
  },
  async deleteAdasMatrixInfoLookup({ state, dispatch }, id) {
    const r = await startLoading(dispatch, 'deleteAdasMatrixInfoLookup', () => http.get(`admin/deleteAdasMatrixInfoLookup?id=${id}`))
    return r.data
  },
  async saveAdasMatrixInfoLookup({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveAdasMatrixInfoLookup', () => http.post('admin/saveAdasMatrixInfoLookup', data))
    commit(types.SET_ADAS_MATRIX_INFO_ID, r.data)
    return r.data
  },
  async getAdasLinks({ commit, dispatch }, id) {
    commit(types.RESET_ADAS_LINKS)
    const r = await startLoading(dispatch, 'getAdasLinks', () => http.get(`alldata/getLinkManage?adaslinks=${id}`))
    commit(types.SET_ADAS_LINKS, r.data)
    return r.data
  },
  resetAdasLinks({ commit }) {
    commit(types.RESET_ADAS_LINKS)
  },
  setLink({ commit }, data) {
    commit(types.SET_ADAS_LINK, data)
  },
  async createAdasLinks({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'createAdasLinks', () => http.post('alldata/createAdasLinks', data))
    return r.data
  },
  async removeAdasLinks({ commit, dispatch }, links) {
    const r = await startLoading(dispatch, 'removeAdasLinks', () => http.post('alldata/removeLinksManage', links))
    commit(types.REMOVE_ADAS_LINKS, links)
    return r.data
  },
  async saveAdasLinks({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveAdasLinks', () => http.post('alldata/saveAdasLinks', data))
    return r.data
  },
  async pullAlldataLinks({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'pullAlldataLinks', () => http.post('alldata/saveLinksByVehicle', data))
    return r.data
  },
  async updateAdasLinks({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'updateAdasLinks', () => http.post('alldata/updateAdasLinks', data))
    return r.data
  },
  async getAdasMakeMatrixCategories({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getAdasMakeMatrixCategories', () => http.get('admin/getAdasMakeMatrixCategories'))
    commit(types.SET_MATRIX_CATEGORIES, r.data)
    return r.data
  },
  async moveAdasMakeMatrix({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'moveAdasMakeMatrix', () => http.get(`admin/moveAdasMakeMatrix?id=${data.id}&to=${data.to}`))
    return r.data
  },
  async getMakeExceptions({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getMakeExceptions', () => http.get(`admin/getAdasMakeExclusions?id=${id}`))
    commit(types.SET_MAKE_EXCEPTIONS, r.data)
    return r.data
  },
  async saveMakeException({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveMakeException', () => http.post('admin/saveAdasMakeExclusion', data))
    return r.data
  },
  async deleteMakeException({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'deleteMakeException', () => http.get(`admin/deleteAdasMakeExclusion?id=${id}`))
    return r.data
  },
  async checklistMatrixVehicleKeywordsTriggersExport({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'checklistMatrixVehicleKeywordsTriggersExport', () =>
      http.get('admin/checklistMatrixVehicleKeywordsTriggersExport')
    )
    commit(types.SET_MATRIX_KEYWORDS_TRIGGERS, r.data)
    return r.data
  },
  async checklistMatrixAdasInfoExport({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'checklistMatrixAdasInfoExport', () =>
      http.get(`admin/checklistMatrixAdasInfoExport?source=${data.source}&isInactive=${data.isInactive}&vehicleMake=${data.vehicleMake}`)
    )
    commit(types.SET_MATRIX_ADAS_INFO, r.data)
    return r.data
  },
  async getMakeExceptionLookups({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'getMakeExceptionLookups', () =>
      http.get(`admin/getMakeExceptionLookups?make=${data.make}&adasChecklistMatrix=${data.adasChecklistMatrix}`)
    )
    commit(types.SET_MAKE_EXCEPTION_LOOKUPS, r.data)
    return r.data
  },
  async getModelVariability({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getModelVariability', () =>
      http.get(`adas/vehicleChecklistMatrixVehicleModel?adasChecklistMatrixVehicle=${id}`)
    )
    commit(types.SET_MODEL_VARIABILITY, r.data)
    return r.data
  },
  async saveModelVariability({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveModelVariability', () => http.post('adas/saveVehicleChecklistMatrixVehicleModel', data))
    return r.data
  },
  updateNoScrubItem({ commit }, data) {
    commit(types.UPDATE_NOSCRUB_DATA, data)
  },
  getNoScrubItem({ commit }, id) {
    commit(types.SET_NOSCRUB, id)
  },
  async getNoScrubList({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getNoScrubList', () =>
      http.get('admin/getAdasNoScrubList', {
        params: options
      })
    )
    commit(types.SET_NOSCRUBLIST, r.data)
    return r.data
  },
  async saveNoScrubItem({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveNoScrub', () => http.post('admin/saveAdasNoScrubList', data))
    return r.data
  },
  async deleteNoScrubItem({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'deleteNoScrub', () => http.get(`admin/deleteAdasNoScrubList?id=${id}`))
    return r.data
  },
  resetCalibrations({ commit }) {
    commit(types.RESET_CALIBRATIONS)
  },
  async getSystemCalibrations({ commit, dispatch }, systemType) {
    const r = await startLoading(dispatch, 'getSystemCalibrations', () => http.get(`adasmatrix/systemCalibrations?systemType=${systemType}`))
    commit(types.SET_SYSTEM_CALIBRATIONS, r.data)
    return r.data
  },
  async deleteCalibration({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'deleteCalibration', () =>
      http.get(`adasmatrix/removeCalibration?systemType=${data.systemType}&calibrationType=${data.calibrationType}`)
    )
    return r.data
  },
  resetPrices({ commit }) {
    commit(types.RESET_PRICING)
  },
  async getCalibrationPricing({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getCalibrationPricing', () => http.get(`adasmatrix/getCalibrationPricing?calibrationType=${id}`))
    commit(types.SET_CALIBRATION_PRICING, r.data)
    return r.data
  },
  async saveCalibrationPricing({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveCalibrationPricing', () => http.post('adasmatrix/saveCalibrationPricing', data))
    return r.data
  },
  initBlueprintInfoLookup({ commit }) {
    commit(types.INIT_BLUEPRINT_INFO_LOOKUP)
  },
  updateBlueprintInfoLookup({ commit }, data) {
    commit(types.UPDATE_BLUEPRINT_INFO_LOOKUP, data)
  },
  async getBlueprintInfoLookups({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getBlueprintInfoLookups', () =>
      http.get('blueprint/getBlueprintInfoLookups', {
        params: options
      })
    )
    commit(types.SET_BLUEPRINT_INFO_LOOKUPS, r.data)
    return r.data
  },
  async getBlueprintInfoLookup({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getBlueprintInfoLookup', () => http.get(`blueprint/getBlueprintInfoLookup?id=${id}`))
    commit(types.SET_BLUEPRINT_INFO_LOOKUP, r.data)
    return r.data
  },
  async deleteBlueprintInfoLookup({ state, dispatch }, id) {
    const r = await startLoading(dispatch, 'deleteBlueprintInfoLookup', () => http.delete(`blueprint/deleteBlueprintInfo?id=${id}`))
    return r.data
  },
  async saveBlueprintInfoLookup({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveBlueprintInfoLookup', () => http.post('blueprint/saveBlueprintInfo', data))
    commit(types.SET_BLUEPRINT_INFO_ID, r.data)
    return r.data
  },
  async reorderAdasMatrixInfoLookups({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'reorderAdasMatrixInfoLookups', () =>
      http.post('admin/reorderAdasMatrixInfoLookups', data)
    )
    return r.data
  },
  async getDecodeScrubRules({ commit, dispatch }, options) {
    const r = await startLoading(dispatch, 'getDecodeScrubRules', () =>
      http.get('adasmatrix/getDecodeScrubRules', {
        params: options
      })
    )
    commit(types.SET_DECODE_SCRUB_RULES, r.data)
    return r.data
  },
  async getDecodeScrubRule({ commit, dispatch }, decodeScrubMatrix) {
    const r = await startLoading(dispatch, 'getDecodeScrubRule', () =>
      http.get(`adasmatrix/getDecodeScrubRule?decodeScrubMatrix=${decodeScrubMatrix}`)
    )
    commit(types.SET_DECODE_SCRUB_RULE, r.data)
    return r.data
  },
  async saveDecodeScrubRule({ commit, dispatch }, data) {
    const r = await startLoading(dispatch, 'saveDecodeScrubRule', () => http.post('adasmatrix/saveDecodeScrubRule', data))
    return r
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/actions.js